import { PaginationInfo } from './../../_models/pagination-info';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'iq-central-front-end-learning-paths',
  templateUrl: './learning-paths.component.html',
  styleUrls: ['./learning-paths.component.scss'],
})
export class LearningPathsComponent implements OnInit, OnDestroy {
  sub: Subscription = new Subscription();
  learningPaths: any[] = [];
  paginationInfo: PaginationInfo;
  filteredLearningPath: any;
  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.getResolvedData();
  }

  getResolvedData() {
    this.sub.add(
      this.route.data.subscribe((res) => {
        this.learningPaths = this.filteredLearningPath =
          res['resolvedData'].learningPaths['responseResult'].learningPaths;
        this.paginationInfo =
          res['resolvedData'].learningPaths['responseResult'].paginationInfo;
      })
    );
  }

  filter(query: string) {
    this.learningPaths = query
      ? this.filteredLearningPath.filter((c) =>
          c.name.toLowerCase().includes(query.toLowerCase())
        )
      : this.filteredLearningPath;
  }

  sortByDate() {
    this.learningPaths.sort(
      (a, b) =>
        new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
    );
  }

  sortByName() {
    this.learningPaths.sort((a, b) => {
      if (a.name < b.name) return -1;
      else if (a.name > b.name) return 1;
      else return 0;
    });
  }

  sortByRestriction() {
    this.learningPaths.sort((a, b) => {
      if (a.restriction < b.restriction) return -1;
      else if (a.restriction > b.restriction) return 1;
      else return 0;
    });
  }

  sortByCourseLength() {
    this.learningPaths.sort((a, b) => {
      if (a.courses.length < b.courses.length) return -1;
      else if (a.courses.length > b.courses.length) return 1;
      else return 0;
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
